var _react_refresh_temp_1;
export const ExitAppFlow = () => null;
_react_refresh_temp_1 = ExitAppFlow;
$RefreshReg$(_react_refresh_temp_1, "ExitAppFlow");
